import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API, getAuthHeaders } from '../../utils/adminAuth';

export default function AuditLogViewer() {
  const [logs, setLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);

  const loadLogs = async () => {
    if (showLogs) { setShowLogs(false); return; }
    try {
      const res = await axios.get(`${API}/admin/audit-logs`, { headers: getAuthHeaders() });
      setLogs(res.data);
      setShowLogs(true);
    } catch { toast.error('Failed to load logs'); }
  };

  const actionColors = {
    page_edit: 'text-blue-400',
    product_update: 'text-purple-400',
    order_update: 'text-cyan-400',
    settings_update: 'text-yellow-400',
    login: 'text-green-400',
    team_edit: 'text-emerald-400',
  };

  return (
    <div className="bg-[#141414] border border-white/5 p-4 sm:p-6" data-testid="audit-log-section">
      <div className="flex items-center justify-between mb-2">
        <div>
          <p className="text-white text-sm font-sans font-medium">Audit Log</p>
          <p className="text-white/40 text-xs font-sans">Track all admin actions</p>
        </div>
        <button
          onClick={loadLogs}
          className="text-[#1C7D3F] text-xs font-sans hover:text-[#2E9B50] transition-colors"
          data-testid="toggle-audit-logs"
        >
          {showLogs ? 'Hide' : 'View Logs'}
        </button>
      </div>
      {showLogs && (
        <div className="mt-3 max-h-64 overflow-y-auto space-y-1" data-testid="audit-log-list">
          {logs.length === 0 && <p className="text-white/30 text-xs py-4 text-center font-sans">No actions logged yet</p>}
          {logs.map((log, idx) => (
            <div key={idx} className="flex items-start gap-2 py-1.5 border-b border-white/5 last:border-0">
              <span className={`text-[10px] uppercase font-mono px-1.5 py-0.5 bg-white/5 ${actionColors[log.action] || 'text-white/50'}`}>
                {log.action?.replace('_', ' ')}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-white/60 text-xs font-sans truncate">{log.details || log.target}</p>
                <p className="text-white/30 text-[10px] font-sans">
                  {log.admin_name} &middot; {new Date(log.timestamp).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
